import { ChangeDetectorRef, Component } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { OnboardingBundles } from './onboarding-bundles.service';

@Component({
  selector: 'rto-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class RtoAppComponent {
  public loading: boolean = true;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private router: Router,
    protected cdRef: ChangeDetectorRef,
    private onboardingBundles: OnboardingBundles,
  ) {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          this.cdRef.detectChanges();
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          this.cdRef.detectChanges();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  public ngOnInit(): void {
    if (environment.analytics) {
      this.loadGrowsumo();
    } else {
      // TODO remove after testing
      (<any>window).loadGrowsumo = this.loadGrowsumo.bind(this);
    }
  }

  private loadGrowsumo(): void {
    const growsumoBundle = this.onboardingBundles.create({
      name: 'growsumo',
      url: 'https://snippet.growsumo.com/growsumo.min.js',
    });

    growsumoBundle
      .load()
      .pipe(
        filter(status => status.loaded),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe(() => {
        const growsumo = (<any>window).growsumo;
        growsumo._initialize(environment.growsumoPublicKey);
      });
  }
}
